// HorizontalMenu.tsx
import React from 'react';
import { Menu } from 'antd';

interface HorizontalMenuProps {
  currentView: string;
  setCurrentView: (view: string) => void;
}

const HorizontalMenu: React.FC<HorizontalMenuProps> = ({
  currentView,
  setCurrentView,
}) => {
  return (
    <Menu
      id='homeHorizantalMenu'
      mode='horizontal'
      selectedKeys={[currentView]}
      onClick={({ key }) => setCurrentView(key)}
    >
      <Menu.Item key='assets'>Assets</Menu.Item>
      <Menu.Item key='goals'>Goals</Menu.Item>
      <Menu.Item key='budget'>Budget</Menu.Item>
      <Menu.Item key='liabilities'>Liabilities</Menu.Item>
    </Menu>
  );
};

export default HorizontalMenu;
